<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="header">
<div class="hgroup">
<h3></h3>
<h1>Dedication</h1>
</div>
</div>
<h5 style="text-align: center;">
	To Sharly</h5>
<h5 style="text-align: center;">
	for the magic of believing</h5>
<p>
</p>
<p>
</p>
<p>
</p>
<div>
<p>
</p>
<p>
</p>
<p>
</p>
<p>
</p>
<p>
</p>
</div>
<p>
</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap112887.vue?76b23e8e